export default "__VITE_ASSET__D7SLiQs4__"